import * as tools from "@/utils/tools";
// import ksBridge from '@ks/ks-bridge'
import Cookies from "js-cookie";
//import setup from '@/utils/setup'
import kylogger from "@/utils/log";
// import { openApp } from '#imports'
import open from "@ky/sdk/dist/open/index";
import request from "@ky/sdk/dist/request";
// import yoda from '@yoda/bridge'
//import yoda from '@ks/yoda-js-sdk'
// import * as yoda from "@yoda/bridge";
// import request from "@/composables/request";

export default defineNuxtPlugin((nuxtApp) => {
  request.interceptors.request.use((config) => {
    if (
      process.env.CODE_ENV &&
      process.env.CODE_ENV !== "production" &&
      process.env.CODE_ENV !== "spg"
    ) {
      const landId = "PRT.test";
      config.headers = {
        "trace-context": `{"landId":"${landId}"}`,
      };
    }
    return config;
  });

  // setup(nuxtApp.vueApp)
  const app = nuxtApp.vueApp;
  console.log("==process.client", process.client);
  const globalProperties = nuxtApp.vueApp.config.globalProperties;
  globalProperties.$log = kylogger;
  globalProperties.$nativeLog = kylogger;
  // globalProperties.$ksBridge = ksBridge
  // globalProperties.$yoda = yoda;
  globalProperties.$cookie = Cookies;
  globalProperties.$tools = tools;
  globalProperties.$openApp = open;
  globalProperties.$request = request;
  kylogger.collect("CLICK", "start");
  // 报错监控
});
